import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions';
import RefreshLineIcon from 'remixicon-react/RefreshLineIcon';
import useSocket from '../../../hooks/useSocket';
import { isAdmin, isAdminAgent } from '../../../helpers/commonFunction';
import SocketActions from '../../../redux/socket/actions';

const PendingCountDealer = () => {
    const dispatch = useDispatch();
    const { getPendingDprCountdealer } = dailyPlanRequestActions;
    const { dprCountResult, dprCountLoading } = useSelector((state) => state.dailyPlanRequest);
    const { tokenData } = useSelector((state) => state.auth);
    const { getPendingDPRCountForSocketList } = SocketActions;


    useSocket('Daily Plan Request Pending updated', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getPendingDPRCountForSocketList());
        }
    });


    const [showBox, setShowBox] = useState(false);

    const fetchPendingCount = () => {
        dispatch(getPendingDprCountdealer());
    };

    useEffect(() => {
        dispatch(getPendingDprCountdealer());
    }, [dispatch]);


    const dealerList = Array.isArray(dprCountResult)
        ? dprCountResult.filter(item => item && item.DealerName)
        : dprCountResult && dprCountResult.DealerName
            ? [dprCountResult]
            : [];

    return (
        <div className="row mb-2">
            <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <div className="d-flex align-items-center">
                        <input
                            type="checkbox"
                            checked={showBox}
                            onChange={() => setShowBox(prev => !prev)}
                            style={{ marginRight: '6px', cursor: 'pointer' }}
                        />

                        <h5 style={{ fontWeight: 800, marginBottom: 0 }}>
                            Show DPR Pending Count
                        </h5>
                    </div>

                    <RefreshLineIcon
                        onClick={fetchPendingCount}
                        style={{ cursor: 'pointer' }}
                        size={18}
                        color="#8b0303"
                        title="Refresh"
                    />
                </div>
                {showBox && (
                    <div
                        className="dpr-pending-box"
                        style={{
                            width: '100%',
                            maxHeight: '300px',
                            border: '1px solid #dee2e6',
                            borderRadius: '6px',
                            padding: '10px',
                            overflowY: 'auto',
                            background: '#f8f9fa'
                        }}
                    >

                        {dprCountLoading ? (
                            <div
                                className="dashboard-inventory-loader"
                                style={{ marginTop: '20px', textAlign: 'center' }}
                            >
                                <span className="spinner-border spinner-border-lg" role="status" />
                            </div>
                        ) : dealerList.length > 0 ? (

                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '8px',
                                    fontSize: '14px'
                                }}
                            >
                                {dealerList.map((item, index) => (
                                    <span key={index}>
                                        <span
                                            title={item?.DealerName || ''}
                                            style={{ color: '#2f2f2f', fontWeight: 500 }}
                                        >
                                            {item?.DealerName}
                                        </span>

                                        <span
                                            style={{
                                                color: '#dc3545',
                                                fontWeight: 700,
                                                marginLeft: '4px'
                                            }}
                                        >
                                            {item?.PendingCount ?? 0}
                                        </span>

                                        {index !== dealerList.length - 1 && (
                                            <span style={{ color: 'black', fontWeight: '600' }}>,</span>
                                        )}
                                    </span>
                                ))}
                            </div>

                        ) : (
                            <p
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: 0,
                                    color: '#8b0303',
                                    fontWeight: 600

                                }}
                            >
                                No pending data found
                            </p>
                        )}
                    </div>
                )}

            </div>
        </div>

    );
};

export default PendingCountDealer;
